import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportCompleted, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether "Move to Appendix" shows. Appendix is a Diagnosis Evaluation concept:
//   evaluation (DE + step)   -> any section not already on the appendix
//   clinical  (DE + single)  -> editable sections not already on the appendix
// Assessment and clinical Reassessment reports have no appendix.
export const useCanMoveToAppendix = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  const reportType = report.reportType;
  const onAppendix = section.pageLocation === APPENDIX_PAGE_LOCATION;

  if (reportType !== ApiReportReportTypeChoices.DiagnosisEvaluation) return false;
  if (onAppendix) return false;
  if (viewMode === "step") return true;

  // clinical single-page Diagnosis Evaluation
  return !isCompleted && !isReviewPage;
};
